import quotApi from './http'
import { Stock } from '../store'

const stockApi = {
  getRecent: async (code: string) => {
    if (!code) return Promise.resolve({ data : [] })
    return quotApi.get<Stock[]>('/recent/securities', {
      params: { "codes": code },
    })
  },
}

export default stockApi